import { render, staticRenderFns } from "./productAttributes.vue?vue&type=template&id=4141769c&scoped=true"
import script from "./productAttributes.vue?vue&type=script&lang=js"
export * from "./productAttributes.vue?vue&type=script&lang=js"
import style0 from "./productAttributes.vue?vue&type=style&index=0&id=4141769c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141769c",
  null
  
)

export default component.exports